// =============================================================================
// _shared/unleashed/autoSync.ts
// -----------------------------------------------------------------------------
// Shared helpers for the DFV Services -> Unleashed AUTO-sync (model B). Lives in
// _shared so the enqueue helper (src/data/unleashedPushQueue.ts) and the worker
// Edge Function apply the IDENTICAL rule — one predicate, two callers.
//
// ZEPHYR-ONLY AUTO-PUSH GATE (John, 3 Aug 2026): the auto worker and the enqueue
// helper only ever auto-push a DFV Service whose shelter_code starts with "Zephyr"
// (case-insensitive — covers the mixed-case `ZephyrNSW106` and any legacy all-caps
// `ZEPHYR…`). A `TEST…` / non-Zephyr service is NEVER auto-pushed. The MANUAL Sync
// Utilities deliberately bypass this (a `TEST…` service can still be pushed by
// hand for testing) and do not enqueue, so they never hit this gate.
// See docs/unleashed-auto-sync-plan.md §5 / §9.
// =============================================================================

// True when this code is auto-pushable (starts with "Zephyr", any case). Blank /
// null / TEST… → false.
export function isZephyrCode(code: string | null | undefined): boolean {
  return (code ?? "").trim().toLowerCase().startsWith("zephyr");
}
